export enum RequiredFieldParam78 {
  JUSTIFICATION = 'J',
  REASON = 'M',
  BOTH = 'A',
  NONE = 'N'
}

export enum ItemStatus {
  STARTED     = 'I',
  RESTARTED   = 'R',
  PENDING     = 'N',
  INTERRUPTED = 'INT',
  TERMINATE   = 'T',
  SUSPEND     = 'S',
  EXPIRED     = 'V'
}
